import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

/** Kurulum sırrı yalnızca açık kurulum ekranının belleğinde tutulur. */
const TwoFactorSetup = ({ pending, admin = false }) => {
  const [copied, setCopied] = useState(false);
  const [copyError, setCopyError] = useState('');
  const muted = admin ? 'var(--admin-text-secondary)' : 'var(--pusu-muted)';

  if (pending.deliveryChannel !== 'totp') {
    return (
      <p className="text-xs" style={{ color: muted }}>
        <strong>{pending.deliveryTarget}</strong> hedefine gönderilen kodu girerek işlemi tamamlayın.
      </p>
    );
  }

  const copySecret = async () => {
    try {
      await navigator.clipboard.writeText(pending.setupSecret);
      setCopied(true);
      setCopyError('');
    } catch {
      setCopyError('Kopyalanamadı. Kurulum anahtarını seçip elle kopyalayabilirsiniz.');
    }
  };

  return (
    <div className="space-y-3">
      {pending.action === 'enable' && (
        <>
          <p className="text-sm">
            Google Authenticator uygulamasında <strong>+</strong> düğmesine basıp
            QR kodunu tarayın veya kurulum anahtarını girin.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4">
            {pending.setupQr && (
              <img
                src={pending.setupQr}
                alt="Google Authenticator kurulum QR kodu"
                width={176}
                height={176}
                className="rounded-lg shrink-0 max-w-full"
              />
            )}
            <div className="min-w-0 flex-1 w-full space-y-2">
              <label className="block text-xs" style={{ color: muted }}>
                Kurulum anahtarı
                <input
                  readOnly
                  autoComplete="off"
                  spellCheck={false}
                  value={pending.setupSecret || ''}
                  onFocus={(event) => event.target.select()}
                  className={`${admin ? 'admin-input' : 'pusu-input'} mt-1 font-mono text-sm`}
                />
              </label>
              <button
                type="button"
                onClick={copySecret}
                disabled={!pending.setupSecret}
                className={`${admin ? 'admin-btn-secondary' : 'gold-outline-btn px-3 py-2 rounded-lg'} flex items-center gap-2 text-xs`}
              >
                {copied ? <Check size={14} /> : <Copy size={14} />}
                {copied ? 'Anahtar kopyalandı' : 'Anahtarı kopyala'}
              </button>
              {copyError && <p role="status" className="text-xs" style={{ color: muted }}>{copyError}</p>}
              <p className="text-xs" style={{ color: muted }}>
                Elle eklerken anahtar türünü <strong>Zamana dayalı</strong> seçin.
                QR kodunu ve anahtarınızı kimseyle paylaşmayın.
                Telefonunuza erişiminizi kaybederseniz hesabı yeniden eklemek
                için bu anahtarı güvenli bir yerde saklayın.
              </p>
            </div>
          </div>
        </>
      )}
      <p className="text-sm" style={{ color: muted }}>
        Google Authenticator uygulamasındaki güncel 6 haneli kodu girin.
        {pending.action === 'enable' && ' Doğru kodla onaylayana kadar doğrulama açılmaz.'}
        {pending.action === 'disable' && ' Onayladığınızda iki adımlı doğrulama kapatılır.'}
      </p>
    </div>
  );
};

export default TwoFactorSetup;
